require('./brokerWarrantsSellStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @commons
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');

// @components
const { AmountInput } = require('commonsComponents/amountInput');

// @ actions
const BrokerWarrantsSellActions = require('actions/brokerWarrantsSell');

// @constants
const {
    FIRST_STEP,
    BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER,
    BROKER_WARRANTS_SELL_FIELDS_MAXLENGHT_LIMIT,
    NON_NUMERIC_REGEXP,
    MAX_FRACTION_LENGTH_IN_STORE,
    TYPE_WARRANTS
} = require('constants/index');

class BrokerWarrantsSellStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.onHandleLimitPriceChange = this.onHandleLimitPriceChange.bind(this);
        this.handleStockContractChanged = this.handleStockContractChanged.bind(this);
        this.state = {
            titleChangedManually: false
        }
    }

    componentDidMount() {
        const { immBrokerWarrantsSell, immStocksSell, productFile, limitPriceChanged, setSellPrice } = this.props;
        const contractSellNumber = immBrokerWarrantsSell.get('contractSellNumber');

        const stocksContractDropdownOptions = this.buildWarrantsContractDropdownOptions();
        const stocksContractSelectedValue = this.getPrechoosedContract(
            contractSellNumber,
            stocksContractDropdownOptions
        );

        if (!immBrokerWarrantsSell.get('steps').get(FIRST_STEP).get('orderTypeValue')) {
            let sellPrice = productFile.get('sellPrice');
            if (sellPrice) {
                limitPriceChanged(sellPrice);
                setSellPrice(sellPrice);
            }
        }

        const titleQuantity = immStocksSell.get('steps').get(FIRST_STEP).get('titleQuantity');

        if (stocksContractSelectedValue !== -1) {
            this.handleStockContractChanged(stocksContractSelectedValue)
        } else if (stocksContractDropdownOptions.length === 1 && !titleQuantity) {
            this.handleStockContractChanged(stocksContractDropdownOptions[0].value);
        }
    }

    onHandleLimitPriceChange(price) {
        this.props.limitPriceChanged(price);
    }

    getPrechoosedContract(contractSellNumber, options) {
        let optionIndex = -1;
        options.map(option => {
            if (option.contactNumber === contractSellNumber) {
                optionIndex = option.value;
            }
        })
        return optionIndex;
    }

    getWarrantCode() {
        const { immMyInvestments, params } = this.props;

        const warrants = immMyInvestments.getIn(['products', 'warrants', 'stocks']).find(warrant => {
            return params.isin === warrant.get('isin') &&
                params.iso === warrant.get('iso');
        }
        );
        const warrantCode = warrants ? warrants.get('valueCode') + warrants.get('emisionCode') : '';
        return warrantCode;
    }

    buildWarrantsContractDropdownOptions() {
        const { immStocksContracts, immMyInvestments, params } = this.props;

        const warrants = immMyInvestments.getIn(['products', 'warrants', 'stocks']).find(stock => {
            return params.isin === stock.get('isin') && params.iso === stock.get('iso');
        });
        const warrantCode = warrants ? warrants.get('valueCode') + warrants.get('emisionCode') : '';

        const filteredContracts = immStocksContracts.filter(entry => {
            return entry.getIn(['stocks', warrantCode]);
        });

        const processedStocksContract = filteredContracts.map(entry => {
            const newEntry = entry.merge({
                value: entry.get('contactNumber'),
                titlesQuantity: entry.getIn(['stocks', warrantCode, 'sellables']),
                productType: TYPE_WARRANTS
            });

            return newEntry;
        });

        return processedStocksContract.toJS();
    }

    handleStockContractChanged(value) {
        const { immStocksContracts } = this.props;
        const warrantCode = this.getWarrantCode();
        const selectedContract = immStocksContracts.find(entry => {
            return entry.get('contactNumber') === value
        });
        const contractTitles = selectedContract.getIn(['stocks', warrantCode, 'sellables'])

        this.props.stockContractChanged(value, contractTitles);
        if (!this.state.titleChangedManually) {
            this.props.titleQuantityChanged(contractTitles);
        }
    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(NON_NUMERIC_REGEXP, "").trim());
        this.setState({
            titleChangedManually: true
        });
    }

    render() {
        const { immBrokerWarrantsSell, immStocksSell, productFile } = this.props;
        const stocksContractDropdownOptions = this.buildWarrantsContractDropdownOptions();
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const step1 = immBrokerWarrantsSell.get('steps').get(FIRST_STEP);
        const titleQuantity = step1.get('titleQuantity');
        const limitPrice = step1.get('orderTypeValue');
        const errorFlags = step1.get('errorFlags');
        const contractSellNumber = immStocksSell.get('contractSellNumber');
        const comboDisabled = stocksContractDropdownOptions.length === 1;

        let stocksContractSelectedValue = step1.get('stocksContractSelectedValue');
        let titleQuantityValid = step1.get('titleQuantityValid');
        let titleQuantityLimitValid = step1.get('titleQuantityLimitValid');

        if (titleQuantityValid === undefined) {
            titleQuantityValid = true;
        }

        if (titleQuantityLimitValid === undefined) {
            titleQuantityLimitValid = true;
        }

        const resultedErrorState = !titleQuantityValid || !titleQuantityLimitValid;

        if (contractSellNumber) {
            stocksContractSelectedValue = this.getPrechoosedContract(
                contractSellNumber,
                stocksContractDropdownOptions
            );
        }

        let titleQuantityErrorMessage = 'broker-warrantSellStep1TitleQuantityMin';
        if (!titleQuantityLimitValid) {
            titleQuantityErrorMessage = 'broker-warrantSellStep1TitleQuantityMax';
        }

        const productCurrency = productFile.get('currencyCode');

        return (
            <div className="warrants-sell-step1">
                <header className="warrants-sell-step1__header">
                    <h2 className="warrants-sell-step1__header-title">
                        <FormattedText value="broker-warrantsSellViewStep1HeaderTitle" />
                    </h2>
                </header>

                <div className="stocks-warrants-sell-step1__dropdown">
                    <StocksContractDropdown
                        onStockContractChange={this.handleStockContractChanged}
                        options={stocksContractDropdownOptions}
                        selectedValue={stocksContractSelectedValue}
                        placeholder={stocksContractPlaceholder}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER}
                        disabled={comboDisabled}
                    />
                </div>

                <div className="warrants-sell-step1__group-div">
                    <h2 className="warrants-sell-step1__subtitle warrants-sell-step1__subtitle--inline">
                        <FormattedText value="broker-warrantsSellStep1SellForText" />
                    </h2>
                    <h2 className="warrants-sell-step1__subtitle">
                        <FormattedText value="broker-warrantsSellViewStep1TitleQuantityLabel" />
                    </h2>
                    <div className="warrants-sell-step1__text-input-wrapper warrants-sell-step1__text-input-wrapper--left">
                        <InputSafe
                            type="text"
                            value={titleQuantity}
                            autoComplete="off"
                            onChange={this.handleTitleQuantityChanged}
                            maxLength={BROKER_WARRANTS_SELL_FIELDS_MAXLENGHT_LIMIT}
                            errorState={resultedErrorState}
                            errorMessage={formatText(titleQuantityErrorMessage)}
                        />
                    </div>
                </div>

                <div className="warrants-sell-step1__group-div">
                    <h2 className="warrants-sell-step1__subtitle warrants-sell-step1__subtitle--inline">
                        <FormattedText value="broker-warrantsSellViewStep1LimitPriceLabel" /> ({productCurrency})
                    </h2>
                    <div className="warrants-sell-step1__input">
                        <AmountInput
                            amount={limitPrice}
                            callback={this.onHandleLimitPriceChange}
                            error={errorFlags.get('orderTypeValue')}
                            errorMsg={formatText('broker-warrantsBuyViewLimitPriceError')}
                            maxFractionLength={MAX_FRACTION_LENGTH_IN_STORE}
                            language={getLanguage()}
                            hideFocusZero
                        />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerWarrantsSellStep1.propTypes = {
    immMyInvestments: PropTypes.object.isRequired,
    immBrokerWarrantsSell: PropTypes.object.isRequired,
    immStocksSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    limitPriceChanged: PropTypes.func.isRequired,
    setSellPrice: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    productFile: PropTypes.object.isRequired
};

module.exports.constructor = BrokerWarrantsSellStep1;

module.exports.BrokerWarrantsSellStep1 = connect(state => ({
    immMyInvestments: state.brokerMyInvestments,
    immBrokerWarrantsSell: state.brokerWarrantsSell,
    immStocksContracts: state.brokerStocksContract,
    immStocksSell: state.brokerStocksSell,
    productFile: state.brokerProductFile
}), {
    stockContractChanged: BrokerWarrantsSellActions.stockContractChanged,
    limitPriceChanged: BrokerWarrantsSellActions.limitPriceChanged,
    setSellPrice: BrokerWarrantsSellActions.setSellPrice,
    titleQuantityChanged: BrokerWarrantsSellActions.titleQuantityChanged
})(BrokerWarrantsSellStep1);
